import { render, staticRenderFns } from "./ThreeDView.vue?vue&type=template&id=367da07b&scoped=true&"
import script from "./ThreeDView.vue?vue&type=script&lang=js&"
export * from "./ThreeDView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367da07b",
  null
  
)

export default component.exports